import { Navigate, Outlet } from 'react-router-dom'
import useGetUserRole from '@forwardflow/hooks/customHooks/useGetUserRole'

interface RoleBasedRouteProps {
   allowedRoles?: string[]
   excludedRoles?: string[]
   redirectTo?: string
}

const RoleBasedRoute = ({
   allowedRoles = [],
   excludedRoles = [],
   redirectTo = '/dashboard',
}: RoleBasedRouteProps) => {
   const { data: userRoleData, isLoading: isLoadingUserRole } = useGetUserRole()
   const userRoles = userRoleData?.roles ?? []

   if (isLoadingUserRole) {
      // You can return a loading spinner here if needed
      return <div></div>
   }

   // Check if user has any excluded roles
   const hasExcludedRole = excludedRoles.some((role) =>
      userRoles.includes(role)
   )

   // Check if user has required roles (if specified)
   const hasAllowedRole =
      allowedRoles.length === 0 ||
      allowedRoles.some((role) => userRoles.includes(role))

   if (hasExcludedRole || !hasAllowedRole) {
      return <Navigate to={redirectTo} replace />
   }

   return <Outlet />
}

export default RoleBasedRoute
